var Layout = require("enyo/Layout"),
    kind   = require("enyo/kind");

module.exports = kind(/** @lends  app.AppHeader.HeaderLayout.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.HeaderLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var container          = this.container,
            containerNode      = container.hasNode(),
            appView            = container.app.view,
            headerRegionBounds = appView.get("headerRegionBounds") || {},
            headerRegionHeight = headerRegionBounds.height || 0,
            $searchForm        =  container.$.searchForm,
            $repeater          = container.$.results,
            $repeaterPrefix    = $repeater.$.client,
            repeaterWidth;

        if (!containerNode) {
            return;
        }

        $searchForm.applyStyle("padding-top", headerRegionHeight + "px");

        // Repeater prefix cannot be wider than repeater
        repeaterWidth = $repeater.getBounds().width;
        $repeaterPrefix.applyStyle("max-width", repeaterWidth + "px");
    }
});
